"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isError = exports.isCustomError = exports.defekt = void 0;
const defekt_1 = require("./defekt");
Object.defineProperty(exports, "defekt", { enumerable: true, get: function () { return defekt_1.defekt; } });
const isCustomError_1 = require("./isCustomError");
Object.defineProperty(exports, "isCustomError", { enumerable: true, get: function () { return isCustomError_1.isCustomError; } });
const isError_1 = require("./isError");
Object.defineProperty(exports, "isError", { enumerable: true, get: function () { return isError_1.isError; } });
